import BoardRepository from '@src/repositories/BoardRepository';

class BoardService {
  constructor() {
    this.boardRepository = new BoardRepository();
  }

  async createBoard({ data, orgId, divId = null }) {
    return this.boardRepository.create({ data, orgId, divId });
  }

  async updateBoard({ data, orgId, divId = null, boardId }) {
    return this.boardRepository.update({ data, orgId, divId, boardId });
  }

  async deleteBoard({ orgId, divId = null, boardId }) {
    return this.boardRepository.delete({ orgId, divId, boardId });
  }
}

export default BoardService;
